import React from 'react';
import * as d3 from 'd3';


const rowConverterTwo = (name, d) => {
  return {
    Name: name,
    Year: d['時間'].slice(0,4),
    Month: d['時間'].slice(5,d['時間'].length - 1),
    Cost: d[name]
  };
};


const rowConverterThree = (d) => {
  return {
    Name: d['Name'],
    Year: parseInt(d['Year'], 10),
    Month: [
      parseFloat(d['Month'] === '1' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '2' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '3' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '4' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '5' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '6' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '7' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '8' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '9' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '10' ? d['Cost'] : ''), 
      parseFloat(d['Month'] === '11' ? d['Cost'] : ''),
      parseFloat(d['Month'] === '12' ? d['Cost'] : '')]
  };
};


export default class ConvertData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: '',
    };
    this.changeData = this.changeData.bind(this);
    this.convertData = this.convertData.bind(this);
  }

  changeData(data) {
    this.setState({
      data: data
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      let data = '';
      let value = nextProps.value;
      if (value !== '') {
        switch (this.props.itemType) {
          case "vegitables": 
            data = require('../../data/vegitables/' + value + '.csv');
            this.changeData(data); 
            break;
    
          case "fruits":
            data = require('../../data/fruits/' + value + '.csv');
            this.changeData(data);
            break;

          case "grains":
            data = require('../../data/grains/' + value + '.csv');
            this.changeData(data);    
            break;

          case "special":
            data = require('../../data/special/' + value + '.csv');
            this.changeData(data);    
            break;

          case "flowers":
            data = require('../../data/flowers/' + value + '.csv');
            this.changeData(data);    
            break;

          default:
            console.log('Failed to load data.');
        } 
      } 
    }
  }

  shouldComponentUpdate(nextProps) {
    //** prevent componentDidUpdate() entering infinite loop
    if (nextProps.value !== this.props.value) {
      return true;
    }
    return false;
  }

  componentDidUpdate() {
    this.convertData();
  }

  convertData() {
    let datasetOne = [];
    let datasetTwo = [];
    let data = this.state.data;
    let name = this.props.itemChsName + this.props.unit;

    d3.csv(data, (d) => {
      datasetOne.push(rowConverterTwo(name, d));
    }).then(() => {
       for (let j = 0; j < datasetOne.length; j++ ) {  
        let i = datasetOne[j];
        let index = datasetTwo.map(i => i.Year).indexOf(parseInt(i.Year, 10));

        if (index === -1) {
          datasetTwo.push(rowConverterThree(i));
        } else {
          //** push "Cost" of datasetOne to "Month" of datasetTwo in order of Month
          datasetTwo[index].Month[parseInt(i.Month, 10) - 1] = parseFloat(i.Cost, 10);
        }
       }

      this.props.onChange(datasetTwo); //** for only one item
    });
  }

  render() {
    return (
      <div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/containers/processing.js